module.exports = __webpack_public_path__ + "img/redstone.18e46a9e.png";